import { UiControl } from './ui-control.model';
import { BaseControlOption } from '../control-options/control-option.interface';

export class ListBoxControl extends UiControl<any> {

  constructor(id: string, label: string, value: Array<string>, ...options: BaseControlOption[]) {
    super(id, label, value, false, options);

    this.className = "ListBoxControl";
  }

}
